import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import classes from "./Dropdown.module.css";
import { Store } from "react-notifications-component";
import PermissionContext from ".././Store/permission-context";
const Dropdown = (props) => {
  const PCtx = useContext(PermissionContext);
  const [mySubMenu, setmySubMenu] = useState(props.submenu);
  const DontFollowLink = () => {
    PCtx.displayAlert(
      "Oops",
      "You have been logged out. Please login to contnue",
      "danger"
    );
  };

  const setMyDropDown = (ind, value) => {
    let Mn = [...mySubMenu];
    let submn = { ...Mn[ind] };
    submn.HasMouseEntered = value;
    Mn[ind] = submn;
    setmySubMenu(Mn);
  };

  return (
    <ul className={classes.dropdown_ul}>
      {mySubMenu.map((thesubmenu, index) => (
        <li key={index} className={classes.dropdown_li}>
          {PCtx.logged ? (
            <Link
              to={thesubmenu.path}
              className={classes.dropdown_link}
              onClick={() => props.Clicker(thesubmenu.path)}
              onMouseEnter={() => setMyDropDown(index, true)}
              onMouseLeave={() => setMyDropDown(index, false)}
            >
              <span>
                <img
                  src={
                    thesubmenu.HasMouseEntered
                      ? thesubmenu.hoverpicture
                      : thesubmenu.picture
                  }
                  className={classes.menuPix}
                />
              </span>
              {thesubmenu.title}
            </Link>
          ) : (
            <Link
              to="#"
              className={classes.dropdown_link}
              onClick={DontFollowLink}
              onMouseEnter={() => setMyDropDown(index, true)}
              onMouseLeave={() => setMyDropDown(index, false)}
            >
              <span>
                <img
                  src={
                    thesubmenu.HasMouseEntered
                      ? thesubmenu.hoverpicture
                      : thesubmenu.picture
                  }
                  className={classes.menuPix}
                />
              </span>
              {thesubmenu.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default Dropdown;
